// @file fetch link with json api
import { jsonApiFetch, JsonAPIResponse } from './json_api_fetch'
import { Link } from './types'

export interface FetchLinkOptions {
  wallPublicKey?: string
  // The padlet the link is previewed for. Only picks the region that extracts a new URL.
  owningWallPublicKey?: string
}

/**
 * Fetch a link object and response in Json API format
 * @param url url to fetch
 * @param options optional fetch options
 */
export default function fetchLink(url: string, options: FetchLinkOptions = {}): Promise<JsonAPIResponse<Link>> {
  const query: Record<string, string> = { url }
  if (options.wallPublicKey) query.wall_public_key = options.wallPublicKey
  if (options.owningWallPublicKey) query.owning_wall_public_key = options.owningWallPublicKey
  return jsonApiFetch<Link>('links', { query })
}
